export default "__VITE_ASSET__5jv9CescG8lLlhiYdovToQ__";